$(document).on('turbo:load turbo:render', () => {

    let initialSelection = $("#lobbyist_registration_lobbying_year").find(":selected").text();
    if (initialSelection == "Select a lobbying year"){
        $(".lobbying-period-questions").hide();
    }
    else{
        let year = $("#lobbyist_registration_lobbying_year").find(":selected").attr("value");
        let dateRange = `11/1/${year}-10/31/${parseInt(year)+1}`;
        $(".lobbying-period-date-range").append(dateRange)
    }
    $("#lobbyist_registration_lobbying_year").on("change", (e) =>{
        $(".lobbying-period-date-range").empty();
        let selected = $("#lobbyist_registration_lobbying_year").find(":selected").text();
        if (selected != "Select a lobbying year"){
            $(".lobbying-period-questions").show();
            //@ts-ignore
            let dateRange = `11/1/${e.currentTarget.value}-10/31/${parseInt(e.currentTarget.value)+1}`;
            $(".lobbying-period-date-range").append(dateRange)
        }
        else{
            $(".lobbying-period-questions").hide();
        }

    });


});